import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isHome && !scrolled
          ? "bg-transparent"
          : "bg-background-50/95 backdrop-blur-md"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-2 cursor-pointer"
          >
            <span
              className={`font-heading text-xl md:text-2xl font-semibold tracking-wide transition-colors duration-500 ${
                isHome && !scrolled
                  ? "text-background-50"
                  : "text-foreground-900"
              }`}
            >
              华丽的外出
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                isHome && !scrolled
                  ? "text-background-50/90 hover:text-background-50"
                  : "text-foreground-700 hover:text-foreground-950"
              } ${location.pathname === "/" ? "font-semibold" : ""}`}
            >
              首页
            </Link>
            <Link
              to="/category/chuanda-gonglue"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                isHome && !scrolled
                  ? "text-background-50/90 hover:text-background-50"
                  : "text-foreground-700 hover:text-foreground-950"
              } ${location.pathname.startsWith("/category") ? "font-semibold" : ""}`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                isHome && !scrolled
                  ? "text-background-50/90 hover:text-background-50"
                  : "text-foreground-700 hover:text-foreground-950"
              } ${location.pathname === "/about" ? "font-semibold" : ""}`}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer transition-colors ${
              isHome && !scrolled ? "text-background-50" : "text-foreground-900"
            }`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-4">
            <Link
              to="/"
              className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors py-2 cursor-pointer"
            >
              首页
            </Link>
            <Link
              to="/category/chuanda-gonglue"
              className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors py-2 cursor-pointer"
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors py-2 cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}